import { render, staticRenderFns } from "./DoctorPersonListing.vue?vue&type=template&id=0d100f00"
import script from "./DoctorPersonListing.vue?vue&type=script&lang=js"
export * from "./DoctorPersonListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports